module.exports = __webpack_public_path__ + "media/images/icons/loop-square-768d34d0781bc15d4b070d8689997cfa.svg";